import React from "react";
import { NavLink } from "react-router-dom";
import { siteConfig } from "../siteConfig.js";
import logo from "../assets/logo.png";

const links = [
  { to: "/", label: "Home" },
  { to: "/our-app", label: "The App" },
  { to: "/about", label: "About" },
  { to: "/business-functions", label: "Services" },
  { to: "/governance", label: "Governance" },
  { to: "/contact", label: "Contact" },
];

const PlayIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M3.18 23.76c.3.17.64.24.99.19L14.9 12 3.18.05A1.5 1.5 0 0 0 3 .72v22.56c0 .19.06.36.18.48z"/>
    <path d="M19.35 9.29 16.3 7.54 12.83 12l3.47 4.46 3.05-1.75A2 2 0 0 0 20.5 12a2 2 0 0 0-1.15-2.71z"/>
  </svg>
);

export default function NavBar() {
  return (
    <header className="header">
      <div className="container headerInner">
        <NavLink to="/" className="brand">
          <img src={logo} alt={`${siteConfig.appName} logo`} className="brandLogo" loading="eager" />
          <div className="brandText">
            <div className="brandName">{siteConfig.appName}</div>
            <div className="brandTag">by {siteConfig.companyLegalName} · Kenya</div>
          </div>
        </NavLink>

        <nav className="nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) => (isActive ? "navLink active" : "navLink")}
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
          <a
            className="navDownloadBtn"
            href={siteConfig.playStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <PlayIcon />
            Get the App
          </a>
        </nav>
      </div>
    </header>
  );
}
